import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import dialogue from './module/dialogue'
import taskDialogue from './module/taskDialogue'
import survey from './module/survey'
import countermeasureCardDialogue from './module/countermeasureCardDialogue'
import caseStudy from './module/caseStudy'
import {removeToken} from "@/utils/auth";
import router from "@/router";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    itemTypeList: {
      scale: 'ChatAnswerSheet',
      guide_language: 'ChatText',
      user_input: 'ChatSend',
      problem_goal_motive: 'ChatAnswerSheet',
      current_mood_score: 'ChatAnswerSheet',
      mood_recognize_named: 'ChatAnswerSheet',
      auto_mindset_recognize: 'ChatAnswerSheet',
      twelve_mind_distort: 'ChatAnswerSheet',
      cognize_reestablish: 'ChatAnswerSheet',
      happly_exercise_list: 'ChatAnswerSheet',
      behaviour_exercise_plan: 'ChatAnswerSheet',
      primary_troubles_qst: 'ChatProblem',
      trouble_category_qst: 'ChatCheckbox',
      set_goal_qst: 'ChatProblem',
      do_you_agree: 'ChatConfirm',
      my_actions_qst: 'ChatActions',
      mood_ruler_qst: 'ChatEmotionalRuler',
      mood_respond: 'ChatText',
      mood_diary_qst: 'ChatTextarea',
      recall_qst: 'ChatReconstructionCard',
      twelve_problems_qst: 'ChatTwelveProblemsAst',
      categories_qst: 'ChatCheckboxActivity',
      mood_categories_qst: 'ChatEmotion',
      mood_categories: 'ChatEmotionReadOnly',
      mood_describe_qst: 'ChatEmotionDetails',
      recognize_methods_qst: 'ChatAutomatedMindSelect',
      thoughts_describe_qst: 'ChatAutomatedMind',
      strategy_card_qst: 'ChatStrategyCard',
      goal_progress: 'ChatAnswerSheet',
      goal_progress_qst: 'ChatProgressCard',
      strategy_practice: 'ChatAnswerSheet',
      video: 'ChatAnswerSheet',
      case_study: 'ChatAnswerSheet',
      schedule: 'ChatAnswerSheet',
      therapy_calendar: 'ChatAnswerSheet',
      relax_exercise: 'ChatAnswerSheet'
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    userLoginOut() {
      removeToken()
      router.replace({ path: '/login'}).catch(() => console.log(''))
    }
  },
  modules: {
    user,
    app,
    survey,
    dialogue,
    taskDialogue,
    countermeasureCardDialogue,
    caseStudy
  }
})
